import { render, staticRenderFns } from "./visit-stop-case-manage.vue?vue&type=template&id=5d706fc4&scoped=true"
import script from "./visit-stop-case-manage.vue?vue&type=script&lang=ts"
export * from "./visit-stop-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d706fc4",
  null
  
)

export default component.exports